<template>
  <section class="w-full h-[89px] bg-[#EDE9E3] flex items-center">
    <div class="w-full flex flex-col gap-3 px-4">
      <div class="flex justify-between gap-1">
        <div
          class="step"
          :class="steps.indexOf(current) > index && 'done' || current == step && 'active'"
          v-for="(step, index) in quoteSteps"
          :key="step"
        />
      </div>
      <div v-if="customSize" class="flex justify-between items-center step-text">
        <span>Custom Size</span> <span>{{ currentStep }}</span> 
      </div>
      <span v-else v-html="currentText" class="step-text"/>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'
export default { 
  props: {
    steps: Array,
    current: String
  },
  computed: {
    ...mapState('quote', ['lead']),
    customSize () {
      return this.lead?.data?.size === 'CUSTOM'
    },
    quoteSteps() {
      const quoteSteps = ['start', 'useCase', 'size', 'purchaseType', 'condition', 'options']
      if (this.current == 'start') {
        return quoteSteps
      }     
      return this.steps.filter(step => {
        if (quoteSteps.includes(step)) {
          return true
        }
        return false
      })
    },
    currentStep() {
      const totalSteps = this.current == 'start' ? 6 : this.quoteSteps.length
      return `Step ${this.quoteSteps.indexOf(this.current) + 1} of ${totalSteps}`
    },
    currentText() {
      const step = this.currentStep
      switch (this.current) {
      case 'start':
        return `<div class="flex justify-between items-center">
            <span>Availability and Contact</span> <span>${step}</span>
          </div>`
      case 'useCase':
        return `<div class="flex justify-between items-center">
            <span>Container Usage</span> <span>${step}</span>
          </div>`
      case 'size':
        return `<div class="flex justify-between items-center">
            <span>Size Selection</span> <span>${step}</span>
          </div>`
      case 'purchaseType':
        return `<div class="flex justify-between items-center">
            <span>Rent or Buy</span> <span>${step}</span>
          </div>`
      case 'condition':
        return `<div class="flex justify-between items-center">
            <span>Conditions Grades</span> <span>${step}</span>
          </div>`
      case 'options':
        return `<div class="flex justify-between items-center">
            <span>Product Selection</span> <span>${step}</span>
          </div>`
      case 'email-quote':
        return `<div class="flex justify-between items-center">
            <span>Email a Quote</span> <span>${step}</span>
          </div>`
      default:
        return ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .step-text {
    font-size: 14px;
    font-weight: 400;
    line-height: 19.6px;
    letter-spacing: -0.02em;
    color: #334155;
  }
  .step {
    border: 4px solid;
    border-radius: 9999px;
    width: 100%;
    border-color: #FFFFFF;
    background: #FFFFFF;
    height: 0;
  }
  .step.active {
    border-color: #334155;
    background: #334155;
  }
  .step.done {
    border-color: #4D84FF;
    background: #4D84FF;
  }
</style>